import React, { Component } from "react";
import { connect } from 'react-redux';
import { Row, Col, Divider, Button, message, Spin } from 'antd';
import { ongoingQCSettingsAppAction } from '../../../redux_actions/admin.state.action';

import "../../../asset/style/manualmode/qc_settings_app.css";
import {get, get_response} from "../../../helper/request";

class SetPositionsApp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            scannerName: '',
            slot1: '',
            slot2: '',
            slot3: '',
            slot4: '',
            slot5: '',
            slot6: '',
            niagraPos: ''
        }

    }

    componentDidMount = () => {
        this.getScannerName();
    }

    getScannerName = () => {
        this.props.dispatch(ongoingQCSettingsAppAction(this.props.adminState, true));
        let url = `/server/get_scanner_name/`;
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        scannerName: response.data,
                    })
                    this.getPositions();
                }
                else {
                    console.log(response);
                    message.error("Not able to fetch values!!", 2.5);
                    this.props.dispatch(ongoingQCSettingsAppAction(this.props.adminState, false));
                }
            })
            .catch(err => {
                console.log(err);
                message.error("Not able to fetch values!!", 2.5);
                this.props.dispatch(ongoingQCSettingsAppAction(this.props.adminState, false));
            })
    }

    getPositions = () => {
        this.props.dispatch(ongoingQCSettingsAppAction(this.props.adminState, true));
        let partsOfUrl = "/server/get_setup_positions/";
        // let url = `/server/scano/` + this.props.currentState.deviceId + `/` + partsOfUrl;
        get_response(partsOfUrl)
            .then(response => {
                if (response.status === 200) {
                    let data = response.data;
                    this.setState({
                        slot1: data["Slot 1"] || "",
                        slot2: data["Slot 2"] || "",
                        slot3: data["Slot 3"] || "",
                        slot4: data["Slot 4"] || "",
                        slot5: data["Slot 5"] || "",
                        slot6: data["Slot 6"] || "",
                        niagraPos: data["niagara"] || "",
                    })
                }
                else {
                    console.log(response);
                    message.error("Not able to fetch values!!", 2.5);
                }
                this.props.dispatch(ongoingQCSettingsAppAction(this.props.adminState, false));
            })
            .catch(err => {
                console.log(err);
                message.error("Not able to fetch values!!", 2.5);
                this.props.dispatch(ongoingQCSettingsAppAction(this.props.adminState, false));
            })
    }

    getQCSettingsRow = (haveRowStyle, heading, value, inputField, button) => {
        return (
            <Row style={haveRowStyle ? { marginTop: 5 } : {}}>
                <Col offset={2} span={7}>
                    <b>{heading}</b>
                </Col>
                <Col span={7}>
                    <span>{value}</span>
                </Col>
                <Col span={1}>
                    {inputField}
                </Col>
            </Row>
        )
    }

    getQCSettingsButton = (text, onClickMethod, id) => {
        return (
            <Button type="primary" size="small" id={id} onClick={(event) => {
                event.stopPropagation();
                onClickMethod(id)
                }}>
                {text}
            </Button>
        )
    }

    setPosition = (slot) => {
        let url = `/server/set_setup_positions/?slot=`+slot
        get_response(url)
        .then(response => {
            if (response.status === 200) {
                let data = response.data;
                this.setState({
                    slot1: data["Slot 1"] || "",
                    slot2: data["Slot 2"] || "",
                    slot3: data["Slot 3"] || "",
                    slot4: data["Slot 4"] || "",
                    slot5: data["Slot 5"] || "",
                    slot6: data["Slot 6"] || "",
                    niagraPos: data["niagara"] || "",
                })
            }
        })
    }

    setDropWindow = (name=null) => {
        console.log(this.props.currentState.deviceId)
        let partsOfUrl = `api~settings~set-drop-window/`
        let url = `/server/scano/` + this.props.currentState.deviceId + `/` + partsOfUrl
        get(url)
    }

    render() {

        return (
            <Row className="app-parent overlayed-component qc-settings-app-width">
                <div style={{marginTop: 10}}>
                    <Spin spinning={this.props.adminState.motion_app_action}>
                        <Divider />
                        <h4 className="qc-settings-app-heading">Scanner Details</h4>
                        <Divider />
                        <Row>
                            <Col offset={2} span={7}>
                                <b>Scanner Name:</b>
                            </Col>
                            <Col span={12}>
                                <span>{this.state.scannerName}</span>
                            </Col>
                        </Row>
                        <Divider />
                        <h4 className="qc-settings-app-heading">Set Drop Window</h4>
                        <Divider />
                        <Row style={{ marginLeft: 5 }}>
                            <Col offset={2} span={7}>
                                {this.getQCSettingsButton('Use Current ZPosition as Center of the Drop Window', this.setDropWindow, "")}
                            </Col>
                        </Row>
                        <Divider />
                        <h4 className="qc-settings-app-heading">Auto Mapping Positions</h4>
                        <Divider />
                        {this.getQCSettingsRow(true, 'Slot-1: ', this.state.slot1,
                            this.getQCSettingsButton('Use Current Position', this.setPosition, "Slot 1")
                        )}
                        {this.getQCSettingsRow(true, 'Slot-2: ', this.state.slot2,
                            this.getQCSettingsButton('Use Current Position', this.setPosition, "Slot 2")
                        )}
                        {this.getQCSettingsRow(true, 'Slot-3: ', this.state.slot3,
                            this.getQCSettingsButton('Use Current Position', this.setPosition, "Slot 3")
                        )}
                        {this.getQCSettingsRow(true, 'Slot-4: ', this.state.slot4,
                            this.getQCSettingsButton('Use Current Position', this.setPosition, "Slot 4")
                        )}
                        {this.getQCSettingsRow(true, 'Slot-5: ', this.state.slot5,
                            this.getQCSettingsButton('Use Current Position', this.setPosition, "Slot 5")
                        )}
                        {this.getQCSettingsRow(true, 'Slot-6: ', this.state.slot6,
                            this.getQCSettingsButton('Use Current Position', this.setPosition, "Slot 6")
                        )}
                        <Divider />
                        <h4 className="qc-settings-app-heading">Niagara Position</h4>
                        <Divider />
                        {this.getQCSettingsRow(true, 'Point: ', this.state.niagraPos,
                            this.getQCSettingsButton('Use Current Position', this.setPosition, "niagara")
                        )}
                    </Spin>
                </div>
                <br />
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        adminState: state.adminUrlReducer
    }
}

export default connect(mapStateToProps)(SetPositionsApp);
